import React from 'react';
import Layout from '../../components/UI/Layout/Layout' 
import List from '../../components/Entity/Salaries/List/List';

const SalariesPage = () => {
  return <Layout title={'ხელფასები'} fullwidth={0}>
  
      <List></List>
    
  </Layout>;
}

export default SalariesPage;
